import { render, staticRenderFns } from "./TabMoonPhases.vue?vue&type=template&id=d4997bbc&scoped=true"
import script from "./TabMoonPhases.vue?vue&type=script&lang=js"
export * from "./TabMoonPhases.vue?vue&type=script&lang=js"
import style0 from "./TabMoonPhases.vue?vue&type=style&index=0&id=d4997bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4997bbc",
  null
  
)

export default component.exports